import { event } from '@empiriecom/module-components/EventBridge';

class AddToBasketProvider {
  public toggleIcon = (): void => {
    event.trigger('toggleBasketIcon');
  };
}

export default new AddToBasketProvider();
